{
  "fr": {
    "dashboard": {
      "greetings": {
        "afternoon": "Bon après-midi {first_name}",
        "evening": "Bonsoir {first_name}",
        "morning": "Bonjour {first_name}",
        "night": "Bonne nuit {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Vous n'avez aucun élément en attente pour le moment.",
        "caught_up_title": "Vous êtes à jour",
        "status_active": "En cours",
        "status_completed": "Terminé",
        "status_planned": "Planifié",
        "todo_now_title": "À faire maintenant",
        "journey_title": "Votre parcours",
        "journey_select_unit_title": "Sélectionnez une unité",
        "journey_select_unit_subtitle": "Choisissez une unité ci-dessus pour voir son parcours.",
        "journey_no_active_title": "Aucune étape active",
        "journey_no_active_subtitle": "Cette unité n'a pas encore commencé son parcours.",
        "progress_completed": "{completed} / {total} terminé(s)",
        "previous_label": "Jalons précédents",
        "completed_count": "{count} terminé(s)",
        "upcoming_more": "Encore {count} jalons à venir",
        "open_action": "Ouvrir",
        "due_before": "Avant le {date}",
        "show_more_tasks": "Afficher {count} tâche de plus | Afficher {count} tâches de plus",
        "show_less": "Afficher moins"
      },
      "titles": {
        "activityFeed": "Activités",
        "assignedTasks": "Mes Tâches",
        "newsFeed": "Fil d'Actualité",
        "ongoingTickets": "En Cours",
        "openTickets": "Ouvert",
        "progress": "Progression",
        "tickets": "Conversations",
        "totalTickets": "Toutes les conversations",
        "unreadTickets": "Non Lu",
        "yourAssignedTickets": "Assignées à vous"
      }
    }
  }
}
